import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useChooseShopStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            width: '100%',
            minHeight: '100vh',
            height: '100vh',
            backgroundColor: theme.colors.espresso_brown,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            justifyContent: 'stretch',
            position: 'relative',
            overflow: 'hidden',
        },
        imageSection: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
        },
        bottlesImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
        },
        contentSection: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2rem',
            padding: '2rem',
            position: 'relative',
            '@media (max-width: 1024px)': {
                gap: '1.75rem',
            },
            '@media (max-width: 768px)': {
                gap: '1.5rem',
                padding: '1.5rem',
            },
            '@media (max-width: 480px)': {
                gap: '1.25rem',
                padding: '1rem',
            },
        },
        logoImage: {
            width: '25vw',
            maxWidth: '300px',
            minWidth: '200px',
            height: 'auto',
            '@media (max-width: 1024px)': {
                width: '30vw',
                maxWidth: '280px',
                minWidth: '180px',
            },
            '@media (max-width: 768px)': {
                width: '35vw',
                maxWidth: '250px',
                minWidth: '160px',
            },
            '@media (max-width: 480px)': {
                width: '50vw',
                maxWidth: '200px',
                minWidth: '140px',
            },
        },
        title: {
            fontFamily: theme.fonts.apex,
            fontSize: '2rem',
            fontWeight: 700,
            color: theme.colors.ivory_beige,
            textAlign: 'center',
            letterSpacing: '0.1rem',
            margin: 0,
            '@media (max-width: 1024px)': {
                fontSize: '1.75rem',
            },
            '@media (max-width: 768px)': {
                fontSize: '1.5rem',
            },
            '@media (max-width: 480px)': {
                fontSize: '1.25rem',
            },
        },
        buttonsContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
            width: '100%',
            maxWidth: '400px',
            '@media (max-width: 1024px)': {
                gap: '1.25rem',
                maxWidth: '380px',
            },
            '@media (max-width: 768px)': {
                gap: '1rem',
                maxWidth: '350px',
            },
            '@media (max-width: 480px)': {
                gap: '0.875rem',
                maxWidth: '300px',
            },
        },
        shopButton: {
            fontFamily: theme.fonts.apex,
            fontSize: '1.75rem',
            fontWeight: 700,
            color: theme.colors.espresso_brown,
            backgroundColor: theme.colors.ivory_beige,
            border: 'none',
            borderRadius: '0',
            padding: '1.25rem 2rem',
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.colors.latte_cream,
                transform: 'scale(1.05)',
                boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.3)',
            },
            '@media (max-width: 1024px)': {
                fontSize: '1.5rem',
                padding: '1.125rem 1.75rem',
            },
            '@media (max-width: 768px)': {
                fontSize: '1.25rem',
                padding: '1rem 1.5rem',
            },
            '@media (max-width: 480px)': {
                fontSize: '1.125rem',
                padding: '0.875rem 1.25rem',
            },
        },
    };
});

export default useChooseShopStyles;